/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UpdateUserRoleRelationDto,
    UpdateUserRoleRelationDtoFromJSON,
    UpdateUserRoleRelationDtoFromJSONTyped,
    UpdateUserRoleRelationDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateUserRoleRelationsCommand
 */
export interface UpdateUserRoleRelationsCommand {
    /**
     * 
     * @type {Array<UpdateUserRoleRelationDto>}
     * @memberof UpdateUserRoleRelationsCommand
     */
    relations: Array<UpdateUserRoleRelationDto>;
}

export function UpdateUserRoleRelationsCommandFromJSON(json: any): UpdateUserRoleRelationsCommand {
    return UpdateUserRoleRelationsCommandFromJSONTyped(json, false);
}

export function UpdateUserRoleRelationsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserRoleRelationsCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'relations': ((json['relations'] as Array<any>).map(UpdateUserRoleRelationDtoFromJSON)),
    };
}

export function UpdateUserRoleRelationsCommandToJSON(value?: UpdateUserRoleRelationsCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'relations': ((value.relations as Array<any>).map(UpdateUserRoleRelationDtoToJSON)),
    };
}


